import { v4 as uuid } from "uuid";
import { GameCard, GameState } from "@/types/card";

import type { ModifierKey } from "@/utils/tokens/modifiers";


export function actCardCounterIncrement(
  state: GameState,
  gridIndex: number,
  cellIndex: number,
) {
  const newState = [...state];

  const newGridCell = [...newState[gridIndex]];
  const newCard = newGridCell[cellIndex];

  let counter = newCard.counter ?? 0;
  counter++;
  newCard.counter = counter;

  newState[gridIndex][cellIndex] = newCard;

  return newState;
}

export function actCardCounterDecrement(
  state: GameState,
  gridIndex: number,
  cellIndex: number,
) {
  const newState = [...state];

  const newGridCell = [...newState[gridIndex]];
  const newCard = newGridCell[cellIndex];

  let counter = newCard.counter ?? 0;
  counter--;
  newCard.counter = counter;

  newState[gridIndex][cellIndex] = newCard;

  return newState;
}

export function actSpawnCard(
  state: GameState,
  gridIndex: number,
  card: GameCard,
) {
  const newState = [...state];
  const newCard: GameCard = {
    ...card,
    id: card.id + uuid(),
    img: card.img,
    type: card.type,
    isTapped: false,
    counter: 0,
  };

  newState[gridIndex].push(newCard);
  return newState as GameState;
}

// export function actToggleWard(
//   gridItems: GameState,
//   gridIndex: number,
//   cardIndex: number,
// ) {
//   const next = structuredClone(gridItems);
//   const card = next[gridIndex]?.[cardIndex] as GameCard | undefined;
//   if (!card) return gridItems;

//   card.modifiers = card.modifiers ?? {};
//   card.modifiers.ward = !card.modifiers.ward;

//   return next;
// }

export function actToggleModifier(
  gridItems: GameState,
  gridIndex: number,
  cardIndex: number,
  key: ModifierKey,
) {
  const next = structuredClone(gridItems);
  const card = next[gridIndex]?.[cardIndex] as GameCard | undefined;
  if (!card) return gridItems;

  card.modifiers = card.modifiers ?? {};
  card.modifiers[key] = !card.modifiers[key];

  return next;
}

export function actToggleWard(gridItems: GameState, gridIndex: number, cardIndex: number) {
  return actToggleModifier(gridItems, gridIndex, cardIndex, "ward");
}
